module.exports = __webpack_public_path__ + "media/images/accountSection__settingsClose-ed7affba76ff4eb321e7bda9566e4a20.png";